import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import { AssetDot } from '@/shared/components/AssetDot';

const SHOWN = ['FX', 'Rates', 'Macro', 'Credit', 'Commodities'];

type Props = { value: string; onChange: (assetClass: string) => void };

/** One asset class at a time, or All. The chosen pill is filled. */
export function AssetPills({ value, onChange }: Props) {
  const options: [string, string][] = [['All', ''], ...SHOWN.map((a): [string, string] => [a, a])];
  return (
    <Stack direction="row" role="group" aria-label="Asset class" sx={{ gap: 0.75, flexWrap: 'wrap' }}>
      {options.map(([label, asset]) => {
        const isOn = asset === value;
        return (
          <ButtonBase key={label} aria-pressed={isOn} onClick={() => { onChange(asset); }} sx={pillSx(isOn)}>
            {asset ? <AssetDot assetClass={asset} /> : null}
            {label}
          </ButtonBase>
        );
      })}
    </Stack>
  );
}

export const pillSx = (isOn: boolean) => ({
  gap: 0.75,
  height: 32,
  px: 1.5,
  borderRadius: 4,
  fontSize: '0.8125rem',
  fontWeight: 500,
  border: 1,
  borderColor: isOn ? 'text.primary' : 'divider',
  bgcolor: isOn ? 'text.primary' : 'background.paper',
  color: isOn ? 'background.paper' : 'text.primary',
  transition: 'background-color 160ms, color 160ms, border-color 160ms, transform 160ms',
  '&:hover': { borderColor: isOn ? 'text.primary' : 'surface.border' },
  '&:active': { transform: 'scale(0.97)' },
});
